import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

/**
 * Reusable DataGrid styles
 * These styles must be applied via sx prop to maintain proper specificity over MUI defaults
 */

/**
 * Creates the sx prop styles for DataGrid with sticky column
 * @param stickyColumnField - The field name of the sticky column (default: 'fixedColumn')
 * @returns SxProps object for MUI DataGrid
 */
export const getDataGridStyles = (stickyColumnField = 'fixedColumn'): SystemStyleObject<Theme> => ({
  /* Regular column header styles (overrides global CSS) */
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: '#eeeeee',
    padding: '12px 8px',
    borderRight: '1px solid #c9c9c9',
    borderBottom: '1px solid #c9c9c9',
    boxSizing: 'border-box',
  },

  /* Sticky column positioning */
  // Sticky column header (configurable via stickyColumnField parameter)
  [`& .MuiDataGrid-columnHeader[data-field="${stickyColumnField}"]`]: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    borderRight: '2px solid #757575',
    borderLeft: '1px solid #c9c9c9',
    fontWeight: 500,
  },
  // Sticky column table cells (configurable via stickyColumnField parameter)
  [`& .MuiDataGrid-cell[data-field="${stickyColumnField}"]`]: {
    position: 'sticky',
    left: 0,
    zIndex: 2,
    borderRight: '2px solid #757575',
    borderLeft: '1px solid #c9c9c9',
    fontWeight: 500,
    fontSize: 14,
  },
});
